export const Assets = [
    {
        url: "/video/backyard-5sec-1080.mp4",
        name: "bg"
    }
];